import { Stack } from "@chakra-ui/react";

export default function RollingLine() {
    return(
        <Stack as={"div"} className="border_moving">
        </Stack>
    )
}